// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../../../Fields/FieldsImport';
import { FieldsFactory } from '../../../Factory/FieldsFactory';
export class AlgorithmGainersLosersExchangeGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.ALGORITHM_GAINERS_LOSERS_EXCHANGE_GROUP, null, pfixFieldSet);
    }
    get ExchangeName() {
        return super.GetValue(FieldsFactory.FIELD_MD_EXCHANGE_NAME);
    }
}
